export function getPrevWeek(numWeeks: number): Date {
    let today = new Date();
    return new Date(today.getFullYear(), today.getMonth(), today.getDate() - Math.floor(numWeeks * 7));
}
